<template>
<div>
    <div v-if="toastMessage" class="error-toast">
        <span>{{ toastMessage }}</span>
        <button class="toast-close" @click="toastMessage = ''">&times;</button>
    </div>
    <div v-if="initilizingCart">
        <blurryLoader />
    </div>
    <div v-if="submitted" class="processing-overlay">
        <div class="processing-box">
            <img src="@/assets/images/loading_icon_payment.svg" loading="lazy" alt="">
            <div class="text-block-1101">Processing payment.</div>
            <div class="text-block-1102">Please wait...</div>
        </div>
    </div>
    <div class="error_popup popup-desktop" v-if="addressError" style="display:block; z-index: 9999; position: fixed; top: 0; left: 0; width: 100%; height: 100%; background: rgba(0,0,0,0.5);">
        <div class="error_box error-pop-desk">
            <img src="@/assets/images/icon_Urgent.svg" loading="lazy" alt="" class="image-496">
            <div class="text-block-1101">Invalid Address</div>
            <div class="text-block-1102">FedEx and UPS our carriers do not deliver to P.O. Box addresses. Please enter a valid street address.</div>
            <div class="text-block-1102">
                <a href="#" @click.prevent="addressError=false;" class="submit-button-3 new w-button" style="color:#fff;margin-top: 0px;margin-bottom: 0px;">Update Address</a>
            </div>
        </div>
    </div>
    <div class="error_popup popup-desktop" v-if="cartError" style="display:block; z-index: 9999; position: fixed; top: 0; left: 0; width: 100%; height: 100%; background: rgba(0,0,0,0.5);">
        <div class="error_box error-pop-desk">
            <img src="@/assets/images/icon_Urgent.svg" loading="lazy" alt="" class="image-496">
            <div class="text-block-1101">Cart Not Found</div>
            <div class="text-block-1102">No cart items found. Either the user has completed checkout or the cart doesn't exist. Please check your link.</div>
            <div class="text-block-1102">
                <a href="/home" class="submit-button-3 new w-button" style="color:#fff;margin-top: 0px;margin-bottom: 0px;">Go to Home</a>
            </div>
        </div>
    </div>
    <section class="section_semaco-top">
        <div class="semaco-top-wrap">
            <div class="semaco_topdiv">
                <a href="#" class="w-inline-block"><img sizes="(max-width: 479px) 67.2265625px, 84.03125px" srcset="@/assets/images/Logo-p-500.png 500w, @/assets/images/Logo-p-800.png 800w, @/assets/images/Main_Logo.png 1000w" alt="" src="@/assets/images/Main_Logo.png" loading="lazy" class="image-31" :class="{'image-31-desk' : !isMobile}"></a>
            </div>
        </div>
    </section>
    <div class="section_semaglutidecheckout" :key="checkoutKey" v-if="!cartError">

        <div class="semaco_wrap" v-if="!isMobile">
            <div class="semaco_div">
                <div class="semaco_payinfo">
                    <div class="step-4">
                        <div class="div-block-1291">
                            <h1 class="heading-8 _1 b checkout">Everything included. One low monthly price.</h1>
                            <div class="text-block-250 checkout">No Membership Fees. No Upcharging for Higher Dosage.</div>
                        </div>
                        <div class="w-form">
                            <form class="step-2-left-payment-form new-checkout new-mobile checkout-desk" @submit.prevent="getStripeToken()">
                                <a href="#" class="link-block-13 w-inline-block"></a>
                                    <div class="div-block-1292">
                                    <!-- Express Checkout (Apple Pay / Google Pay / Klarna) -->
                                    <div class="express-checkout-section">
                                        <div class="express-checkout-box" :class="{ 'single-option': !canMakeExpressCheckout }" v-show="canMakeExpressCheckout || paymentInfo.payment_terms !== 1">
                                            <div v-show="canMakeExpressCheckout" id="express-checkout-element" class="express-checkout-btn-container"></div>
                                            <button v-show="paymentInfo.payment_terms !== 1" type="button" class="klarna-btn" :disabled="submitted" @click="payWithKlarna">
                                                <span class="klarna-btn-text">Buy now, pay later with</span>
                                                <img class="klarna-logo" src="@/assets/images/Klarna.png" alt="Klarna" />
                                            </button>
                                        </div>
                                        <div class="pe-divider" v-show="canMakeExpressCheckout || paymentInfo.payment_terms !== 1">
                                            <div class="pe-divider-line"></div>
                                            <span>OR</span>
                                            <div class="pe-divider-line"></div>
                                        </div>
                                    </div>
                                    <div class="pe-label-7x">Select Payment Method</div>
                                    <div id="payment-element"></div>
                                    <label for="email" class="pe-label-7x" style="margin-top: 20px; display: block;">Shipping Address</label>
                                    <div :class="{ 'address-highlight': addressBlink }">
                                        <google-places-autocomplete :api-key="googleMapsApiKey" @address-updated="getAddressData" />
                                    </div>

                                    <!-- Checkout API Error Banner -->
                                    <div v-if="checkoutErrorMessage" class="checkout-error-banner">
                                        <div class="checkout-error-banner-content">
                                            <span class="checkout-error-icon">&#9888;</span>
                                            <div class="checkout-error-text">
                                                <div class="checkout-error-heading">Payment failed</div>
                                                <div class="checkout-error-message">{{ checkoutErrorMessage }}</div>
                                                <div class="checkout-error-helper">Please check your card details and try again, or use a different payment method.</div>
                                            </div>
                                        </div>
                                    </div>
                                    <button class="submit-button-3 new w-button" :disabled="submitted" style="color:#fff">
                                        <span v-if="submitted"><img src="@/assets/images/submitted.svg"></span>
                                        <span v-else>Buy Now and Save</span>
                                    </button>
                                    <div class="w-form-fail" style="display:block" v-if="paymentError">
                                        <div>{{errorMessage}}</div>
                                    </div>
                                </div>
                                <div class="div-block-1154 div-block-1154-centered">
                                    <input type="hidden" name="xxTrustedFormCertUrl" id="xxTrustedFormCertUrl_0" ref="trustedFormUrl" value="">
                                    <div class="text-block-252">
                                        By clicking "Buy Now and Save" or checking out with Apple or Google Pay you agree to enroll in a
                                        {{ paymentTermLabels[paymentInfo.payment_terms].duration }}
                                        program billed
                                        {{ paymentTermLabels[paymentInfo.payment_terms].billingFrequency }}
                                        , with automatic renewal and charges until canceled. You authorize recurring payments and confirm that you have read and agree to the <a :href="`${appMainWeb}/returns`" target="_blank">Refund Policy</a>, <a :href="`${appMainWeb}/terms`" target="_blank">Terms and Conditions</a>, <a :href="`${appMainWeb}/terms`" target="_blank">Terms of Use</a>, <a :href="`${appMainWeb}/privacy`" target="_blank">Privacy Policy</a>, <a :href="`${appMainWeb}/hipaa`" target="_blank">HIPAA Notice</a>, and <a :href="`${appMainWeb}/telehealth-consent`" target="_blank">Telehealth Consent</a>, and are at least 18 years of age.
                                    </div>
                                </div>
                            </form>
                            <div class="w-form-done">
                                <div>Thank you! Your submission has been received!</div>
                            </div>
                            <div class="w-form-fail">
                                <div>Oops! Something went wrong while submitting the form.</div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="semaco_orderdetails">
                    <div class="plan-select-div">
                        <div class="select-plan-text">Select Your Plan</div>
                        <div class="text-block-1300"><strong>Click Below to Choose, </strong><span class="text-block-1300">How You’d Like to Pay</span></div>
                        <div class="plan-choices-div">
                            <div class="plans-div">
                                <div class="sema-plan-div">
                                    <a href="#" class="plan-link quart w-inline-block" :class="{'planactive' : paymentInfo.payment_terms==3}" @click.prevent="paymentInfo.payment_terms=3">
                                        <div class="plan-type-text">3 Month Plan</div>
                                        <div class="plan-price">${{getMonthlyPrice(3).toFixed(2)}} a Month</div>
                                        <div class="plan-price">${{getTotalPrice(3).toFixed(2)}} Total 3 Months</div>
                                        <div class="plan-price"><strong>{{getSavingsText(3)}}</strong></div>
                                    </a>
                                </div>
                                <div class="sema-plan-div">
                                    <a href="#" class="plan-link monthly w-inline-block" :class="{'planactive' : paymentInfo.payment_terms==1}" @click.prevent="paymentInfo.payment_terms=1">
                                        <div class="plan-type-text">Monthly Plan</div>
                                        <div class="plan-price">${{getFirstMonthPrice().toFixed(2)}} / month</div>
                                        <div class="plan-price">${{getRegularMonthlyPrice().toFixed(2)}} Thereafter</div>
                                        <div class="plan-price"><strong>Industry Low Pricing</strong></div>
                                    </a>
                                </div>
                            </div>
                        </div>
                        <div class="plan-choices-div _6month" style="border-color: #dfdfdf; border-width: 2px; position: relative;">
                            <span class="plan-badge popular-badge">Popular</span>
                            <div class="plans-div">
                                <div class="sema-plan-div" style="width: 100%;">
                                    <a href="#" class="plan-link quart w-inline-block" :class="{'planactive' : paymentInfo.payment_terms==6}" @click.prevent="paymentInfo.payment_terms=6">
                                        <div class="plan-type-text">6 Months Plan</div>
                                        <div class="plan-price">${{getMonthlyPrice(6).toFixed(2)}} a Month</div>
                                        <div class="plan-price">${{getTotalPrice(6).toFixed(2)}} Total 6 Months</div>
                                        <div class="plan-price"><strong>{{getSavingsText(6)}}</strong></div>
                                        <div class="plan-price">3 month Supply today & 3 more in 90 Days.</div>

                                    </a>
                                </div>
                            </div>
                        </div>
                        <p style="text-align: center;justify-content: center; color: red;font-size: 16px; font-weight: bold; font-family: Mulish, sans-serif;">Lock In a 12 Month Prescription Today<br />So You Don't Run Out!</p>
                        <div class="plan-choices-div _6month" style="border-color: #ff4c46; position: relative;">
                            <span class="plan-badge recommended-badge">Recommended</span>
                            <div class="plans-div">
                                <div class="sema-plan-div" style="width: 100%;">
                                    <a href="#" class="plan-link quart w-inline-block" :class="{'planactive' : paymentInfo.payment_terms==12}" @click.prevent="paymentInfo.payment_terms=12">
                                        <div class="plan-type-text">12 Months Plan <span class="inline-badge">Huge Savings</span></div>
                                        <div class="plan-price">${{getMonthlyPrice(12).toFixed(2)}} a Month</div>
                                        <div class="plan-price">${{getTotalPrice(12).toFixed(2)}} Total 12 Months</div>
                                        <div class="plan-price"><strong>{{getSavingsText(12)}}</strong></div>
                                        <div class="plan-price">3 month supply every 90 days for a year</div>

                                    </a>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="summary-desk">
                        <div class="monthly-order" style="display:block;">
                            <div class="div-block-960 new">
                                <div class="div-block-976">
                                    <div class="div-block-974">
                                        <div class="checkout-product-div"><img :src="getImage" loading="lazy" sizes="100vw" :srcset="`${getImage} 500w, ${getImage} 800w, ${getImage} 1080w`" alt=""></div>
                                        <div class="div-block-975" style="background-color: transparent;">
                                            <div class="text-block-161" style="color: #fff;"></div>
                                        </div>
                                    </div>
                                    <div>
                                        <div class="product-name-2">{{getcartItems.name}}</div>
                                        <div class="text-block-850" v-if="getcartItems.name==='Tirzepatide'">Compounded with B6 (Pyridoxine)</div>
                                        <div class="text-block-850" v-else>Compounded with B12 (Cyanocobalamin)</div>
                                        <div class="text-block-850" v-if="paymentInfo.payment_terms===12">3 month supply every 90 days for a year.</div>
                                        <div class="text-block-850" v-else-if="paymentInfo.payment_terms===6">3 month Supply today & 3 more in 90 Days.</div>
                                        <div class="text-block-850" v-else>3 Months Supply.</div>
                                        <!--<div class="text-block-850" style="font-size: 12px;cursor: pointer;margin-top:10px" @click="changeItem(getcartItems.name)"><strong>Made a mistake? Click to change meds.</strong></div>-->
                                    </div>
                                </div>
                                <div class="div-block-1778">
                                    <div class="item-price-text">${{(getCurrentPrice() - (paymentInfo.discount || 0)).toFixed(2)}}</div>
                                    <div class="text-block-849">{{paymentTermLabels[paymentInfo.payment_terms].billingLabel}}</div>
                                </div>
                            </div>
                        </div>
                        <div class="plan-inclusions-div">
                            <div class="inclusion-div">
                                <div class="inclusion-left"><img src="@/assets/images/icon_PM_No_Increase_blk.png" loading="lazy" alt="" class="image-473">
                                    <div class="inclusion-text">All Dosages Same Price.</div>
                                </div>
                                <div class="text-block-1035">FREE</div>
                            </div>
                            <div class="inclusion-div">
                                <div class="inclusion-left"><img src="@/assets/images/icon_board-copy.svg" loading="lazy" alt="" class="image-473">
                                    <div class="inclusion-text">Telehealth Visit<sup>*</sup></div>
                                </div>
                                <div class="text-block-1035">FREE</div>
                            </div>
                            <div class="inclusion-div">
                                <div class="inclusion-left"><img src="@/assets/images/icon_support.svg" loading="lazy" alt="" class="image-473">
                                    <div class="inclusion-text">Unlimited Clinical Chat<sup>*</sup></div>
                                </div>
                                <div class="text-block-1035">FREE</div>
                            </div>
                            <div class="inclusion-div">
                                <div class="inclusion-left"><img src="@/assets/images/icon_delivery.svg" loading="lazy" alt="" class="image-473">
                                    <div class="inclusion-text">Overnight Cold Shipping</div>
                                </div>
                                <div class="text-block-1035">FREE</div>
                            </div>
                        </div>
                        <div class="quarterly-details-div" style="padding-top:5px">
                            <p style="font-size: 8px;line-height: normal; padding-bottom:15px">*The clinician consultation fee is included in the program cost and is paid directly to our independent doctor network partners. This fee is processed regardless of whether you qualify for treatment or receive a prescription. If your consultation results in a denial, you will not be responsible for this payment.</p>
                            <div class="quart-deet-header-div">
                                <div class="text-block-1036">{{paymentTermLabels[paymentInfo.payment_terms].planName}}:</div>
                                <div class="div-block-1903" style="background: #00A36C;">
                                    <div class="text-block-1037" style="color:#fff" v-if="paymentInfo.payment_terms==3">Big Savings</div>
                                    <div class="text-block-1037" style="color:#fff" v-else-if="paymentInfo.payment_terms==6">Huge Savings</div>
                                    <div class="text-block-1037" style="color:#fff" v-else-if="paymentInfo.payment_terms==12">Best Price</div>
                                    <div class="text-block-1037" style="color:#fff" v-else>${{getMonthlyDiscount().toFixed(0)}} Off Your 1st Month!</div>
                                </div>
                            </div>
                            <ul role="list" class="list-5">
                                <li class="list-item-4" v-for="(point, index) in getPlanPoints" :key="`point-plan${index}`">
                                    <div class="text-block-1038">{{point.header}}</div>
                                    <div class="text-block-1039">{{point.sub_header}}</div>
                                </li>
                            </ul>
                        </div>
                        <div class="couponcodediv _1 coupon new">
                            <div class="form-block-15 w-form">
                                <form>
                                    <div class="div-block-1897 checkout">
                                        <input class="text-field-55 coupon new w-input" maxlength="256" v-model="couponInput" name="field-3" data-name="Field 3" placeholder="Coupon Code" type="text" id="field-3" required>
                                        <a href="#" class="button-103 new w-button" style="color:#fff" @click.prevent="handleCouponSubmit()">Apply</a>
                                    </div>
                                    <div class="w-form-fail" style="display: block;" v-if="couponError">
                                        <div>Invalid Coupon.</div>
                                    </div>
                                </form>
                            </div>
                        </div>
                        <div class="text-block-90">Monthly Access. <span class="text-span-13">Cancel anytime. </span></div>
                    </div>
                </div>
            </div>
        </div>

        <!-- Mobile version - structure is the same but with mobile-specific classes -->
        <div class="sema-checkout-mobile" v-else>
            <div class="semaco_orderdetails">
                <div class="plan-select-div">
                    <div class="select-plan-text">Select Your Plan</div>
                    <div class="text-block-1300"><strong>Click Below to Choose, </strong><span class="text-block-1300">How You’d Like to Pay</span></div>
                    <div class="plan-choices-div">
                        <div class="plans-div">
                            <div class="sema-plan-div">
                                <a href="#" class="plan-link quart w-inline-block" :class="{'planactive' : paymentInfo.payment_terms==3}" @click.prevent="paymentInfo.payment_terms=3">
                                    <div class="plan-type-text">3 Month Plan</div>
                                    <div class="plan-price">${{getMonthlyPrice(3).toFixed(2)}} a Month</div>
                                    <div class="plan-price">${{getTotalPrice(3).toFixed(2)}} Total 3 Months</div>
                                    <div class="plan-price"><strong>{{getSavingsText(3)}}</strong></div>
                                </a>
                            </div>
                            <div class="sema-plan-div">
                                <a href="#" class="plan-link monthly w-inline-block" :class="{'planactive' : paymentInfo.payment_terms==1}" @click.prevent="paymentInfo.payment_terms=1">
                                    <div class="plan-type-text">Monthly Plan</div>
                                    <div class="plan-price">${{getFirstMonthPrice().toFixed(2)}} / month</div>
                                    <div class="plan-price">${{getRegularMonthlyPrice().toFixed(2)}} Thereafter</div>
                                    <div class="plan-price"><strong>Industry Low Pricing</strong></div>
                                </a>
                            </div>
                        </div>
                    </div>
                    <div class="plan-choices-div _6month" style="border-color: #dfdfdf; border-width: 2px; position: relative;">
                        <span class="plan-badge popular-badge">Popular</span>
                        <div class="plans-div">
                            <div class="sema-plan-div" style="width:100%">
                                <a href="#" class="plan-link quart w-inline-block" :class="{'planactive' : paymentInfo.payment_terms==6}" @click.prevent="paymentInfo.payment_terms=6">
                                    <div class="plan-type-text">6 Months Plan</div>
                                    <div class="plan-price">${{getMonthlyPrice(6).toFixed(2)}} a Month</div>
                                    <div class="plan-price">${{getTotalPrice(6).toFixed(2)}} Total 6 Months</div>
                                    <div class="plan-price"><strong>{{getSavingsText(6)}}</strong></div>
                                    <div class="plan-price">3 month Supply today & 3 more in 90 Days.</div>
                                </a>
                            </div>
                        </div>
                    </div>
                    <p style="text-align: center;justify-content: center; color: red;font-size: 16px; font-weight: bold; font-family: Mulish, sans-serif;">Lock In a 12 Month Prescription Today<br />So You Don't Run Out!</p>
                    <div class="plan-choices-div _6month" style="border-color: #ff4c46; position: relative;">
                        <span class="plan-badge recommended-badge">Recommended</span>
                        <div class="plans-div">
                            <div class="sema-plan-div" style="width:100%">
                                <a href="#" class="plan-link quart w-inline-block" :class="{'planactive' : paymentInfo.payment_terms==12}" @click.prevent="paymentInfo.payment_terms=12">
                                    <div class="plan-type-text">12 Months Plan <span class="inline-badge">Huge Savings</span></div>
                                    <div class="plan-price">${{getMonthlyPrice(12).toFixed(2)}} a Month</div>
                                    <div class="plan-price">${{getTotalPrice(12).toFixed(2)}} Total 12 Months</div>
                                    <div class="plan-price"><strong>{{getSavingsText(12)}}</strong></div>
                                    <div class="plan-price">3 month supply every 90 days for a year</div>
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="summary-desk">
                    <div class="quartely-order">
                        <div class="div-block-960 new">
                            <div class="div-block-976">
                                <div class="div-block-974">
                                    <div class="checkout-product-div"><img :src="getImage" loading="lazy" sizes="100vw" :srcset="`${getImage} 500w, ${getImage} 800w, ${getImage} 1080w`" alt=""></div>
                                    <div class="div-block-975" style="background-color: transparent;">
                                        <div class="text-block-161" style="color: #fff;"></div>
                                    </div>
                                </div>
                                <div>
                                    <div class="product-name-2">{{getcartItems.name}}</div>
                                    <div class="text-block-850" v-if="getcartItems.name==='Tirzepatide'">Compounded with B6 (Pyridoxine)</div>
                                    <div class="text-block-850" v-else>Compounded with B12 (Cyanocobalamin)</div>
                                    <div class="text-block-850" v-if="paymentInfo.payment_terms===12">3 month supply every 90 days for a year.</div>
                                    <div class="text-block-850" v-else-if="paymentInfo.payment_terms===6">3 month Supply today & 3 more in 90 Days.</div>
                                    <div class="text-block-850" v-else>3 Months Supply.</div>
                                    <!--<div class="text-block-850" style="font-size: 12px;cursor: pointer;margin-top:10px" @click="changeItem(getcartItems.name)"><strong>Made a mistake? Click to change meds.</strong></div>-->
                                </div>
                            </div>
                            <div class="div-block-1778">
                                <div class="item-price-text">${{(getCurrentPrice() - (paymentInfo.discount || 0)).toFixed(2)}}</div>
                                <div class="text-block-849">{{paymentTermLabels[paymentInfo.payment_terms].billingLabel}}</div>
                            </div>
                        </div>
                    </div>
                    <div class="monthly-order">
                        <div class="div-block-960 new">
                            <div class="div-block-976">
                                <div class="div-block-974">
                                    <div class="checkout-product-div"><img :src="getImage" loading="lazy" sizes="100vw" :srcset="`${getImage} 500w, ${getImage} 800w, ${getImage} 1080w`" alt=""></div>
                                    <div class="div-block-975" style="background-color: transparent;">
                                        <div class="text-block-161" style="color: #fff;"></div>
                                    </div>
                                </div>
                                <div>
                                    <div class="product-name-2">{{getcartItems.name}}<br></div>
                                    <div class="text-block-850">{{getSupplyDuration}} Supply</div>
                                </div>
                            </div>

                            <div class="div-block-1778">
                                <div class="item-price-text">${{getCurrentPrice()}}</div>
                                <div class="text-block-849">{{paymentTermLabels[paymentInfo.payment_terms].billingLabel}}</div>
                            </div>
                        </div>
                    </div>
                    <div class="plan-inclusions-div">
                        <div class="inclusion-div">
                            <div class="inclusion-left"><img src="@/assets/images/icon_PM_No_Increase_blk.png" loading="lazy" alt="" class="image-473">
                                <div class="inclusion-text">All Dosages Same Price.</div>
                            </div>
                            <div class="text-block-1035">FREE</div>
                        </div>
                        <div class="inclusion-div">
                            <div class="inclusion-left"><img src="@/assets/images/icon_board-copy.svg" loading="lazy" alt="" class="image-473">
                                <div class="inclusion-text">Telehealth Visit<sup>*</sup></div>
                            </div>
                            <div class="text-block-1035">FREE</div>
                        </div>
                        <div class="inclusion-div">
                            <div class="inclusion-left"><img src="@/assets/images/icon_support.svg" loading="lazy" alt="" class="image-473">
                                <div class="inclusion-text">Unlimited Clinical Chat<sup>*</sup></div>
                            </div>
                            <div class="text-block-1035">FREE</div>
                        </div>
                        <div class="inclusion-div">
                            <div class="inclusion-left"><img src="@/assets/images/icon_delivery.svg" loading="lazy" alt="" class="image-473">
                                <div class="inclusion-text">Overnight Cold Shipping</div>
                            </div>
                            <div class="text-block-1035">FREE</div>
                        </div>
                    </div>
                    <div class="quarterly-details-div" style="padding-top:5px">
                        <p style="font-size: 8px;line-height: normal; padding-bottom:15px">*The clinician consultation fee is included in the program cost and is paid directly to our independent doctor network partners. This fee is processed regardless of whether you qualify for treatment or receive a prescription. If your consultation results in a denial, you will not be responsible for this payment.</p>
                        <div class="quart-deet-header-div">
                            <div class="text-block-1036">{{paymentTermLabels[paymentInfo.payment_terms].planName}}:</div>
                            <div class="div-block-1903" style="background: #00A36C;">
                                <div class="text-block-1037" style="color:#fff" v-if="paymentInfo.payment_terms==3">Big Savings</div>
                                <div class="text-block-1037" style="color:#fff" v-else-if="paymentInfo.payment_terms==6">Huge Savings</div>
                                <div class="text-block-1037" style="color:#fff" v-else-if="paymentInfo.payment_terms==12">Best Price</div>
                                <div class="text-block-1037" style="color:#fff" v-else>${{getMonthlyDiscount().toFixed(0)}} Off Your 1st Month!</div>
                            </div>
                        </div>
                        <ul role="list" class="list-5">
                            <li class="list-item-4" v-for="(point, index) in getPlanPoints" :key="`point-plan${index}`">
                                <div class="text-block-1038">{{point.header}}</div>
                                <div class="text-block-1039">{{point.sub_header}}</div>
                            </li>

                        </ul>
                    </div>
                    <div class="couponcodediv _1 coupon new">
                        <div class="form-block-15 w-form">
                            <form id="email-form-4" name="email-form-4" data-name="Email Form 4" method="get" data-wf-page-id="674d4a5a7395cd3bb3e7f579" data-wf-element-id="34cf4a3f-1558-6b5c-91bf-7caa1f520ff6">
                                <div class="div-block-1897 checkout">
                                    <input class="text-field-55 coupon new w-input" maxlength="256" name="field-3" data-name="Field 3" v-model="couponInput" placeholder="Coupon Code" type="text" id="field-3" required>
                                    <a href="#" @click.prevent="handleCouponSubmit()" style="color:#fff" class="button-103 new w-button">Apply</a>
                                </div>
                                <div class="w-form-fail" style="display: block;" v-if="couponError">
                                    <div>Invalid Coupon.</div>
                                </div>
                            </form>
                        </div>
                    </div>
                    <div class="text-block-90">Monthly Access. <span class="text-span-13">Cancel anytime. </span></div>
                </div>
            </div>
            <div class="div-block-1284">
                <div class="w-form">
                    <form class="step-2-left-payment-form new-checkout new-mobile _2" @submit.prevent="getStripeToken()">
                        <!-- Express Checkout (Apple Pay / Google Pay / Klarna) -->
                        <div class="express-checkout-section">
                            <div class="express-checkout-box" :class="{ 'single-option': !canMakeExpressCheckout }" v-show="canMakeExpressCheckout || paymentInfo.payment_terms !== 1">
                                <div v-show="canMakeExpressCheckout" id="express-checkout-element" class="express-checkout-btn-container"></div>
                                <button v-show="paymentInfo.payment_terms !== 1" type="button" class="klarna-btn" :disabled="submitted" @click="payWithKlarna">
                                    <span class="klarna-btn-text">Buy now, pay later with</span>
                                    <img class="klarna-logo" src="@/assets/images/Klarna.png" alt="Klarna" />
                                </button>
                            </div>
                            <div class="pe-divider" v-show="canMakeExpressCheckout || paymentInfo.payment_terms !== 1">
                                <div class="pe-divider-line"></div>
                                <span>OR</span>
                                <div class="pe-divider-line"></div>
                            </div>
                        </div>
                        <div class="pe-label-7x">Select Payment Method</div>
                        <div id="payment-element"></div>
                        <label for="Address" class="pe-label-7x" style="margin-top: 20px; display: block;">Shipping Address</label>
                        <div :class="{ 'address-highlight': addressBlink }">
                            <google-places-autocomplete :api-key="googleMapsApiKey" @address-updated="getAddressData" />
                        </div>
                        <!-- Checkout API Error Banner -->
                        <div v-if="checkoutErrorMessage" class="checkout-error-banner">
                            <div class="checkout-error-banner-content">
                                <span class="checkout-error-icon">&#9888;</span>
                                <div class="checkout-error-text">
                                    <div class="checkout-error-heading">Payment failed</div>
                                    <div class="checkout-error-message">{{ checkoutErrorMessage }}</div>
                                    <div class="checkout-error-helper">Please check your card details and try again, or use a different payment method.</div>
                                </div>
                            </div>
                        </div>
                        <button class="submit-button-3 new w-button" :disabled="submitted" style="color:#fff">
                            <span v-if="submitted"><img src="@/assets/images/submitted.svg"></span>
                            <span v-else>Buy Now and Save</span>
                        </button>

                        <div class="div-block-1154">
                            <input type="hidden" name="xxTrustedFormCertUrl" id="xxTrustedFormCertUrl_0" ref="trustedFormUrl" value="">
                            <div class="text-block-252">
                                By clicking "Buy Now and Save" or checking out with Apple or Google Pay you agree to enroll in a
                                {{ paymentTermLabels[paymentInfo.payment_terms].duration }}
                                program billed
                                {{ paymentTermLabels[paymentInfo.payment_terms].billingFrequency }}
                                , with automatic renewal and charges until canceled. You authorize recurring payments and confirm that you have read and agree to the <a :href="`${appMainWeb}/returns`" target="_blank">Refund Policy</a>, <a :href="`${appMainWeb}/terms`" target="_blank">Terms and Conditions</a>, <a :href="`${appMainWeb}/terms`" target="_blank">Terms of Use</a>, <a :href="`${appMainWeb}/privacy`" target="_blank">Privacy Policy</a>, <a :href="`${appMainWeb}/hipaa`" target="_blank">HIPAA Notice</a>, and <a :href="`${appMainWeb}/telehealth-consent`" target="_blank">Telehealth Consent</a>, and are at least 18 years of age.
                            </div>
                        </div>
                    </form>
                    <div class="w-form-fail" style="display:block" v-if="paymentError">
                        <div>{{errorMessage}} </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div style="height:280px;"></div>
    <footer-section v-if="!cartError && !initilizingCart" />
</div>
</template>

    
<script>
import { loadStripe } from "@stripe/stripe-js"
let stripe = null;
let paymentElements = null;

import GooglePlacesAutocomplete from '../common/GooglePlacesAutocomplete.vue'
import blurryLoader from '../common/blurryLoader.vue'
import FooterElement from '../common/footerElement.vue'
import {
    mapActions,
    mapGetters
} from 'vuex';

export default {
    name: 'CheckoutComponent',
    components: {
        GooglePlacesAutocomplete,
        blurryLoader,
        'footer-section': FooterElement,
    },
    props: ['baseUrl', 'stripeKey', 'googleMapsApiKey'],
    data() {
        return {
            windowWidth: typeof window !== 'undefined' ? window.innerWidth : 1024,
            paymentElement: null,
            expressCheckoutElement: null,
            canMakeExpressCheckout: false,
            hasCardInput: false,
            conversionId: null, // Store c_id from URL
            conversionSent: false, // Track if conversion was sent successfully
            checkoutErrorMessage: '',
            toastMessage: '',
            addressBlink: false,
            paymentAttempts: 0,
            maxPaymentAttempts: 3,
            appName: process.env.VUE_APP_COMPANY,
            appMainWeb: process.env.VUE_APP_HOMEPAGE,
            payment_open: 0,
            paymentError: false,
            initilizingCart: true,
            cartError: false,
            isApplePaySupported: false,
            isGooglePaySupported: false,
            checkoutKey: 1,
            ip_address:'',
            couponValid: true,
            couponError: false,
            submitted: false,
            addressError: false,
            trustUrl: '',
            couponInput: '',
            message: '',
            offer: '',
            customerInfo: {
                id: '',
                addressLine1: '',
                addressLine2: '',
                city: '',
                state: '',
                zip: ''
            },
            paymentInfo: {
                payment_terms: 6,
                user_id: '',
                cardToken: '',
                cardBrand:'',
                amount: 499,
                discount: 0,
                medication: '',
                couponCode: '',
                drug_mode: '',
                couponId: null,
                paymentMethod: null,
                cartItems: [],
                planId: '',
                // Card info from Stripe
                cardBin: '',
                cardLast4: '',
            },
            // Centralized configuration for pricing - easier to maintain
            pricingConfig: {
                    semaglutide: {
                        monthly: {
                            first: 205.99,
                            regular: 205.99
                        },
                        terms: {
                            3: 443.97,
                            6: 743.94,
                            12: 1187.88
                        }
                    },
                    tirzepatide: {
                        monthly: {
                            first: 274.99,
                            regular: 274.99
                        },
                        terms: {
                            3: 641.97,
                            6: 1110.00,
                            12: 1740.00
                        }
                    }
                },
            // Centralized labels for payment terms - easier to maintain
            paymentTermLabels: {
                1: {
                    planName: "Monthly Plan",
                    duration: "monthly",
                    billingFrequency: "monthly",
                    billingLabel: "Billed Monthly",
                    supplyDuration: "Monthly"
                },
                3: {
                    planName: "Quarterly Plan",
                    duration: "3-month",
                    billingFrequency: "quarterly",
                    billingLabel: "Billed Quarterly",
                    supplyDuration: "3 Month"
                },
                6: {
                    planName: "Half yearly Plan",
                    duration: "6-month",
                    billingFrequency: "every 6 months",
                    billingLabel: "Billed Every 6 Months",
                    supplyDuration: "6 Month"
                },
                12: {
                    planName: "yearly Plan",
                    duration: "12-month",
                    billingFrequency: "annually",
                    billingLabel: "Billed Annually",
                    supplyDuration: "12 Month"
                }
            }
        }
    },

    async mounted() {
        // Capture conversion ID early and store it
        this.captureConversionId();
        await this.checkAuthAndInitialize();
        await this.getIpAddress();
        window.addEventListener('resize', this.handleResize);
        window.addEventListener('pageshow', this.handlePageShow);
    },

    beforeDestroy() {
        window.removeEventListener('resize', this.handleResize);
        window.removeEventListener('pageshow', this.handlePageShow);
    },

    created() {

    },

    watch: {
        paymentError(val) {
            if (val) {
                clearTimeout(this._errorTimeout);
                this._errorTimeout = setTimeout(() => { this.paymentError = false; }, 10000);
            }
            if (val && this.errorMessage) {
                this.showToast(this.errorMessage);
            }
        },
        checkoutErrorMessage(val) {
            if (val) {
                this.showToast(val);
            }
        },
        isMobile: {
            immediate: true,
            handler(newVal) {
                console.log('Mobile view:', newVal);
                // Re-mount Stripe elements after DOM swap
                this.$nextTick(() => {
                    if (stripe && !this.initilizingCart && !this.cartError) {
                        this.createPaymentElement();
                        this.createExpressCheckoutElement();
                    }
                });
            }
        },
        'paymentInfo.payment_terms'() {
            this.couponInput = "";
            this.paymentInfo.couponId = null;
            this.couponApplied = false;
            this.paymentInfo.discount = 0;
            this.updateElementsAmount();
        },
        'paymentInfo.discount'() {
            this.updateElementsAmount();
        },
        checkoutKey() {
            // Recreate payment element when checkout updates
            this.$nextTick(() => {
                if (stripe && !this.cartError) {
                    this.createPaymentElement();
                    this.createExpressCheckoutElement();
                }
            });
        }
    },

    methods: {
        ...mapActions([
            'setCartVisibility',
            'clearCart'
        ]),

        handleResize() {
            this.windowWidth = window.innerWidth;
        },

        async getIpAddress() {
            try {
                const response = await fetch('https://api.ipify.org?format=json');
                const data = await response.json();
                this.ip_address = data.ip;
                return data.ip;
            } catch (error) {
                console.error('Error getting IP:', error);
            }
        },

        // Capture conversion ID from URL parameters early
        captureConversionId() {
            try {
                const urlParams = new URLSearchParams(window.location.search);
                this.conversionId = urlParams.get('c_id') || urlParams.get('source_id');

                if (this.conversionId) {
                    console.log('Conversion ID captured:', this.conversionId);
                    // Store in sessionStorage as backup
                    sessionStorage.setItem('affiliate_conversion_id', this.conversionId);
                } else {
                    // Check if we have it in sessionStorage from a previous page
                    this.conversionId = sessionStorage.getItem('affiliate_conversion_id');
                    if (this.conversionId) {
                        console.log('Conversion ID retrieved from storage:', this.conversionId);
                    }
                }
            } catch (error) {
                console.error('Error capturing conversion ID:', error);
            }
        },

        // Enhanced conversion tracking with multiple attempts
        async sendConversionTracking(amountCharged, attempt = 1, productName) {
            const maxAttempts = 3;

            // Fallback: re-read from URL/sessionStorage in case mounted()'s capture missed it
            if (!this.conversionId) {
                try {
                    const urlParams = new URLSearchParams(window.location.search);
                    this.conversionId = urlParams.get('c_id')
                        || urlParams.get('source_id')
                        || sessionStorage.getItem('affiliate_conversion_id')
                        || null;
                } catch (e) {
                    this.conversionId = null;
                }
            }

            if (!this.conversionId || this.conversionSent) {
                return;
            }

            try {
                // Get user name - handle cases where name might not be available
                const userName = this.user?.name || this.user?.firstName || this.user?.email || 'Unknown User';

                // Use the product name passed as parameter (captured before cart was cleared)
                const paymentPlan = this.paymentTermLabels[this.paymentInfo.payment_terms]?.planName || `${this.paymentInfo.payment_terms} Month Plan`;

                console.log(`Sending conversion tracking (attempt ${attempt}):`, {
                    user_id: this.user.id,
                    user_name: userName,
                    product_name: productName,
                    payment_plan: paymentPlan,
                    amount: amountCharged,
                    c_id: this.conversionId
                });

                const response = await this.$axios.post(`https://server.prioritymeds.com/api/call-conversion`, {
                    user_id: this.user.id,
                    user_name: userName,
                    product_name: productName,
                    payment_plan: paymentPlan,
                    amount: amountCharged,
                    c_id: this.conversionId,
                    payment_terms: this.paymentInfo.payment_terms
                }, {
                    timeout: 10000 // 10 second timeout
                });

                if (response.data && response.data.status === 'success') {
                    console.log('Conversion tracking success:', response.data);
                    this.conversionSent = true;
                    // Clear from storage since it was successful
                    sessionStorage.removeItem('affiliate_conversion_id');
                } else {
                    console.warn('Conversion tracking returned unexpected response:', response.data);
                    if (attempt < maxAttempts) {
                        setTimeout(() => this.sendConversionTracking(amountCharged, attempt + 1, productName), 2000);
                    }
                }

            } catch (error) {
                console.error(`Conversion tracking error (attempt ${attempt}):`, error);

                if (attempt < maxAttempts) {
                    // Retry with exponential backoff
                    const delay = Math.pow(2, attempt) * 1000; // 2s, 4s, 8s
                    console.log(`Retrying conversion tracking in ${delay}ms...`);
                    setTimeout(() => this.sendConversionTracking(amountCharged, attempt + 1, productName), delay);
                } else {
                    // All attempts failed
                    console.error('All conversion tracking attempts failed');
                }
            }
        },

        async initStripe() {
            try {
                stripe = await loadStripe(process.env.VUE_APP_STRIPE_KEY);
                paymentElements = stripe.elements({
                    mode: 'payment',
                    amount: this.chargeAmountInCents,
                    currency: 'usd',
                    paymentMethodTypes: ['card'],
                    paymentMethodCreation: 'manual',
                });
            } catch (error) {
                console.error('Failed to initialize Stripe:', error);
            }
        },

        handlePageShow(event) {
            if (event.persisted) {
                this.submitted = false;
            }
        },

        // PRICING METHODS - Centralized pricing logic for easier maintenance
        getProductPricing() {
            return this.getcartItems.name === 'Semaglutide' ?
                this.pricingConfig.semaglutide :
                this.pricingConfig.tirzepatide;
        },

        getFirstMonthPrice() {
            return this.getProductPricing().monthly.first;
        },

        getRegularMonthlyPrice() {
            return this.getProductPricing().monthly.regular;
        },

        getMonthlyDiscount() {
            return this.getRegularMonthlyPrice() - this.getFirstMonthPrice() + parseInt(this.paymentInfo.discount || 0);
        },

        getTotalPrice(term) {
            return this.getProductPricing().terms[term];
        },

        getMonthlyPrice(term) {
            return this.getTotalPrice(term) / term;
        },

        getCurrentPrice() {
            if (this.paymentInfo.payment_terms === 1) {
                return this.getFirstMonthPrice();
            } else {
                return this.getTotalPrice(this.paymentInfo.payment_terms);
            }
        },

        showChatWindow() {
            this.$emit("showChatWindow");
        },

        async handleCouponSubmit() {
            this.errorMessage = null;
            if (!this.couponInput) {
                this.errorMessage = 'Please enter a coupon code';
                return;
            }
            this.paymentInfo.couponCode = this.couponInput;
            await this.validateCoupon();
        },

        async validateCoupon() {
            if (this.couponApplied) return;
            this.couponError = false;
            try {
                const response = await this.$axios.post(`${this.baseUrl}/api/validate-coupon`, {
                    coupon: this.paymentInfo.couponCode,
                    payment_terms: this.paymentInfo.payment_terms
                });

                if (response.data.status === 'success') {
                    if(response.data.c_type===2){
                            // Calculate percentage-based discount
                            const planAmount = this.getCurrentPrice();
                            const discountPercentage = response.data.c_val;
                            this.paymentInfo.couponId = response.data.coupon_id;
                            this.paymentInfo.discount = parseFloat(((planAmount * discountPercentage) / 100).toFixed(2));
                        }else{
                            this.paymentInfo.couponId = response.data.coupon_id;
                            this.paymentInfo.discount = response.data.c_val;
                        }
                        this.couponValid = true;
                        this.couponApplied = true;
                } else {
                    this.couponValid = false;
                    this.couponError = true;
                }
            } catch (error) {
                this.couponValid = false;
                this.couponError = true;
            }
        },

        async checkAuthAndInitialize() {
            this.initilizingCart = true;

            try {
                const response = await this.$axios.get(`${this.baseUrl}/api/get-cart/${this.$route.params.cart_id}`, {
                    headers: {
                        'Content-Type': 'application/json',
                    }
                });

                if (response.data.status === 'success') {
                    let cartItem = response.data.cartItem;

                    try {
                        // Handle offers
                        let keyToDelete = "sema_offer";
                        if (Object.prototype.hasOwnProperty.call(cartItem, keyToDelete)) {
                            this.$store.dispatch('addSemaOffer', cartItem[keyToDelete]);
                            delete cartItem[keyToDelete];
                        }
                        keyToDelete = "tir_offer";
                        if (Object.prototype.hasOwnProperty.call(cartItem, keyToDelete)) {
                            this.$store.dispatch('addTirOffer', cartItem[keyToDelete]);
                            delete cartItem[keyToDelete];
                        }
                    } catch (error) {
                        console.log(error.message);
                    }

                    // Update store and state
                    this.$store.dispatch("doLogin", response.data.userData);
                    this.$store.dispatch('addToCart', cartItem);
                    this.setCartVisibility(false);

                    // Success - hide loading and show content
                    this.initilizingCart = false;
                    this.cartError = false;
                    this.checkoutKey++;

                    // Initialize Stripe and create payment element
                    await this.initStripe();
                    await this.$nextTick();
                    this.createPaymentElement();
                    this.createExpressCheckoutElement();

                } else {
                    this.initilizingCart = false;
                    this.message = response.data.message;
                    this.cartError = true;
                    console.error("Unexpected response:", response.data);
                }
            } catch (error) {
                console.error("Error loading cart:", error);
                this.initilizingCart = false;
                this.message = `${error.message}. Please check the checkout link is correct.`;
                this.cartError = true;
            }
        },

        openPaymentMethod(val) {
            if (val == this.payment_open) {
                this.payment_open = 0;
            } else {
                this.payment_open = val;
            }
        },

        changePaymentTerms(value) {
            this.paymentInfo.payment_terms = value;
        },

        createPaymentElement() {
            if (!paymentElements) return;

            if (this.paymentElement) {
                this.paymentElement.mount('#payment-element');
                return;
            }

            this.paymentElement = paymentElements.create('payment', {
                layout: 'tabs',
                fields: {
                    billingDetails: {
                        address: 'never',
                    },
                },
                defaultValues: {
                    billingDetails: {
                        address: {
                            country: 'US',
                        },
                    },
                },
                wallets: {
                    applePay: 'never',
                    googlePay: 'never',
                    link: 'never',
                },
                terms: {
                    card: 'never',
                },
            });
            this.paymentElement.mount('#payment-element');
            this.paymentElement.on('change', (event) => {
                this.hasCardInput = event.complete;
            });
        },

        createExpressCheckoutElement() {
            if (!paymentElements) return;

            if (this.expressCheckoutElement) {
                this.expressCheckoutElement.mount('#express-checkout-element');
                return;
            }

            // NOTE: First try GPay/Apple Pay only. If neither is available,
            // re-create the element with Link enabled as a fallback.
            this.mountExpressCheckout({ allowLink: false });
        },

        mountExpressCheckout({ allowLink }) {
            const paymentMethods = {
                paypal: 'never',
                amazonPay: 'never',
            };
            if (!allowLink) paymentMethods.link = 'never';

            this.expressCheckoutElement = paymentElements.create('expressCheckout', {
                buttonHeight: 48,
                paymentMethods,
                paymentMethodOrder: ['googlePay', 'applePay', 'link'],
                layout: {
                    overflow: 'never',
                },
            });
            this.expressCheckoutElement.on('ready', ({ availablePaymentMethods }) => {
                // If GPay/Apple Pay aren't available and we haven't tried Link yet,
                // recreate with Link enabled as fallback.
                if (!allowLink && !availablePaymentMethods) {
                    this.expressCheckoutElement.unmount();
                    this.expressCheckoutElement.destroy();
                    this.expressCheckoutElement = null;
                    this.mountExpressCheckout({ allowLink: true });
                    return;
                }
                this.canMakeExpressCheckout = !!availablePaymentMethods;
            });
            this.expressCheckoutElement.on('click', (event) => {
                event.resolve({
                    emailRequired: true,
                    phoneNumberRequired: false,
                    shippingAddressRequired: true,
                    shippingRates: [
                        { id: 'free', displayName: 'Free shipping', amount: 0 },
                    ],
                });
            });
            this.expressCheckoutElement.on('confirm', this.handleExpressCheckoutConfirm);
            this.expressCheckoutElement.mount('#express-checkout-element');
        },

        async handleExpressCheckoutConfirm(event) {
            try {
                this.submitted = true;
                this.paymentError = false;
                this.checkoutErrorMessage = '';

                const { error: submitError } = await paymentElements.submit();
                if (submitError) {
                    event.paymentFailed({ reason: 'fail' });
                    this.paymentError = true;
                    this.errorMessage = submitError.message || 'Payment failed.';
                    this.submitted = false;
                    return;
                }

                const { error, paymentMethod } = await stripe.createPaymentMethod({
                    elements: paymentElements,
                });
                if (error) {
                    event.paymentFailed({ reason: 'fail' });
                    this.paymentError = true;
                    this.errorMessage = error.message || 'Payment failed.';
                    this.submitted = false;
                    return;
                }

                const shipping = event.shippingAddress?.address;
                if (shipping) {
                    this.customerInfo.addressLine1 = shipping.line1 || this.customerInfo.addressLine1;
                    this.customerInfo.addressLine2 = shipping.line2 || this.customerInfo.addressLine2;
                    this.customerInfo.city = shipping.city || this.customerInfo.city;
                    this.customerInfo.state = shipping.state || this.customerInfo.state;
                    this.customerInfo.zip = shipping.postal_code || this.customerInfo.zip;
                }

                if (!this.validateAddress(this.customerInfo)) {
                    event.paymentFailed({ reason: 'fail' });
                    this.paymentError = true;
                    this.errorMessage = 'Please enter a complete shipping address.';
                    this.submitted = false;
                    return;
                }

                this.paymentInfo.cardToken = paymentMethod.id;
                this.paymentInfo.paymentMethod = event.expressPaymentType === 'apple_pay' ? 'apple_pay' : 'google_pay';
                this.paymentInfo.cardLast4 = paymentMethod.card?.last4 || '';
                this.paymentInfo.cardBrand = paymentMethod.card?.brand || '';

                await this.processPayment();
            } catch (error) {
                console.error('Express checkout payment failed:', error);
                event.paymentFailed({ reason: 'fail' });
                this.paymentError = true;
                this.errorMessage = 'Payment failed. Please try again or use a different payment method.';
                this.submitted = false;
            }
        },

        updateElementsAmount() {
            if (paymentElements) {
                paymentElements.update({ amount: this.chargeAmountInCents });
            }
        },

        isPOBox(address) {
            const normalized = address.toLowerCase().replace(/\./g, '').replace(/\s+/g, ' ');
            const poBoxRegex = /\b(po box|post office box|p o box)\b(?:\s*\d{0,6})?/i;
            return poBoxRegex.test(normalized);
        },

        getAddressData(address) {
            if (this.isPOBox(address.street)) {
                this.addressError = true;
                this.customerInfo.addressLine2 = address.address_line2;
                this.customerInfo.city = address.city;
                this.customerInfo.state = address.state;
                this.customerInfo.zip = address.zip;
            } else {
                this.addressError = false;
                this.customerInfo.addressLine1 = address.street;
                this.customerInfo.addressLine2 = address.address_line2;
                this.customerInfo.city = address.city;
                this.customerInfo.state = address.state;
                this.customerInfo.zip = address.zip;
                this.updateAddress();
            }
        },

        async updateAddress() {
            try {
                this.customerInfo.id = this.user.id;
                await this.$axios.post(`${this.baseUrl}/api/save-address`, this.customerInfo);
            } catch (error) {
                console.error('Error updating address:', error);
                throw new Error('Failed to update address');
            }
        },

        validateAddress(address) {
            return address.addressLine1 &&
                address.city &&
                address.state &&
                address.zip;
        },

        async getStripeToken() {
            this.submitted = true;
            this.paymentError = false;
            this.checkoutErrorMessage = '';

            if (!this.validateAddress(this.customerInfo)) {
                this.paymentError = true;
                this.errorMessage = "Please enter a complete shipping address.";
                this.blinkAddress();
                if (window.innerWidth <= 479) {
                    this.$nextTick(() => {
                        document.querySelector('.shipping-address-label')?.scrollIntoView({ behavior: 'smooth', block: 'center' });
                    });
                }
                this.submitted = false;
                return false;
            }

            this.errorReason = false;

            try {
                const { error: submitError } = await paymentElements.submit();
                if (submitError) {
                    this.paymentError = true;
                    this.errorMessage = submitError.message || 'Invalid card details. Please check your card information.';
                    this.submitted = false;
                    return;
                }

                const { error, paymentMethod } = await stripe.createPaymentMethod({
                    elements: paymentElements,
                    params: {
                        billing_details: {
                            name: `${this.user?.first_name || ''} ${this.user?.last_name || ''}`.trim(),
                            email: this.user?.email || '',
                            address: {
                                line1: this.customerInfo.addressLine1,
                                line2: this.customerInfo.addressLine2 || '',
                                city: this.customerInfo.city,
                                state: this.customerInfo.state,
                                postal_code: this.customerInfo.zip,
                                country: 'US',
                            },
                        },
                    },
                });

                if (error) {
                    this.paymentError = true;
                    this.errorMessage = error.message || 'Invalid card details. Please check your card information.';
                    this.submitted = false;
                    return;
                }

                this.paymentInfo.cardToken = paymentMethod.id;
                this.paymentInfo.paymentMethod = 'card';
                this.paymentInfo.cardLast4 = paymentMethod.card?.last4 || '';
                this.paymentInfo.cardBrand = paymentMethod.card?.brand || '';
                this.processPayment();
            } catch (error) {
                console.error(error);
                this.paymentError = true;
                this.errorMessage = 'Invalid card details. Please check your card information.';
                this.submitted = false;
            }
        },

        async payWithKlarna() {
            this.submitted = true;
            this.paymentError = false;
            this.checkoutErrorMessage = '';

            if (!this.validateAddress(this.customerInfo)) {
                this.paymentError = true;
                this.errorMessage = 'Please enter a complete shipping address.';
                this.blinkAddress();
                if (window.innerWidth <= 479) {
                    this.$nextTick(() => {
                        document.querySelector('.shipping-address-label')?.scrollIntoView({ behavior: 'smooth', block: 'center' });
                    });
                }
                this.submitted = false;
                return;
            }
            if (this.isPOBox(this.customerInfo.addressLine1)) {
                this.addressError = true;
                this.submitted = false;
                return;
            }

            try {
                const billingAddr = this.customerInfo;
                const shippingAddress = {
                    addressLine1: this.customerInfo.addressLine1,
                    addressLine2: this.customerInfo.addressLine2,
                    city: this.customerInfo.city,
                    state: this.customerInfo.state,
                    zip: this.customerInfo.zip,
                };

                const totalAmount = this.amountInCents;
                const discountAmount = Math.round((this.paymentInfo.discount || 0) * 100);
                const chargeAmount = totalAmount - discountAmount;

                const response = await this.$axios.post(`${this.baseUrl}/api/create-payment-intent`, {
                    id: this.user.id,
                    amount: chargeAmount,
                    payment_method_types: ['klarna'],
                    user_id: this.user.id,
                    planId: this.getOfferName,
                    payment_terms: this.paymentInfo.payment_terms,
                    couponId: this.paymentInfo.couponId,
                    discount: this.paymentInfo.discount,
                    firstName: this.user.first_name,
                    lastName: this.user.last_name,
                    email: this.user.email,
                    cartTotal: this.cartTotal,
                    shippingAddress,
                    billingAddress: {
                        addressLine1: billingAddr.addressLine1,
                        addressLine2: billingAddr.addressLine2,
                        city: billingAddr.city,
                        state: billingAddr.state,
                        zip: billingAddr.zip,
                    },
                    cartItems: this.cartItems,
                    medication: this.paymentInfo.medication,
                    drug_mode: this.paymentInfo.drug_mode || '',
                });

                const { clientSecret } = response.data;
                const currentUrl = window.location.origin;
                const cartId = this.$route.params.cart_id;
                const returnUrl = `${currentUrl}/weight-loss-payment/${cartId}/klarna-return`;

                const { error } = await stripe.confirmKlarnaPayment(clientSecret, {
                    payment_method: {
                        billing_details: {
                            name: `${this.user.first_name} ${this.user.last_name}`,
                            email: this.user.email,
                            address: {
                                line1: billingAddr.addressLine1,
                                line2: billingAddr.addressLine2 || '',
                                city: billingAddr.city,
                                state: billingAddr.state,
                                postal_code: billingAddr.zip,
                                country: 'US',
                            },
                        },
                    },
                    return_url: returnUrl,
                });

                if (error) {
                    this.paymentError = true;
                    this.errorMessage = error.message || 'Klarna payment failed. Please try again.';
                    this.submitted = false;
                }
            } catch (error) {
                this.paymentError = true;
                this.errorMessage = error.response?.data?.message || 'Failed to initiate Klarna payment. Please try again.';
                this.submitted = false;
            }
        },

        async sendRequest(paymentData) {
            let response = await this.$axios.post(`${this.baseUrl}/api/checkout-stripe`, paymentData)
            return response;
        },

        async processPayment() {
            try {
                this.trustUrl = this.$refs.trustedFormUrl.value;
            } catch (error) {
                console.log("no trust form found")
            }

            let tracking_session_id = "";
                try{
                    tracking_session_id = await window.tracking.assertSession();
                }catch(error){
                    if(window.trackingSessionId){
                        tracking_session_id = window.trackingSessionId;
                    }
                }

            try {
                this.submitted = true;
                this.paymentError = false;
                this.paymentInfo.user_id = this.user.id;
                this.paymentInfo.id = this.user.id;

                // Build cart items with required pricing fields
                const currentPrice = this.getCurrentPrice();
                const retailPrice = this.paymentInfo.payment_terms === 1
                    ? this.getRegularMonthlyPrice()
                    : this.getFirstMonthPrice() + (this.getRegularMonthlyPrice() * (this.paymentInfo.payment_terms - 1));

                this.paymentInfo.cartItems = this.cartItems.map(item => ({
                    ...item,
                    quantity: 1,
                    price: currentPrice,
                    retail_price: retailPrice
                }));

                // Calculate totals based on the pricing
                const calculatedCartTotal = currentPrice;
                const calculatedCartTotalNoDiscount = retailPrice;

                this.paymentInfo.planId = this.getOfferName;
                let paymentData = {
                    ...this.paymentInfo,
                    amount: this.amountInCents,
                    cartTotal: calculatedCartTotal,
                    cartTotalNoDiscount: calculatedCartTotalNoDiscount,
                    offer: this.offer,
                    billingAddress: this.customerInfo,
                    shippingAddress: this.customerInfo,
                    // Include conversion ID in payment data for backend tracking
                    conversion_id: this.conversionId,
                    user_agent : window.navigator.userAgent,
                    ip_address : this.ip_address,
                    tracking_session_id: tracking_session_id
                };

                const response = await this.sendRequest(paymentData);
                let amountCharged = ((paymentData.amount / 100) - (paymentData.discount || 0));

                if (response.data.status === 'success') {
                    try {
                        if (this.paymentInfo.cardLast4) {
                            localStorage.setItem('priority_meds_card_on_file', JSON.stringify({
                                last4: this.paymentInfo.cardLast4,
                                brand: this.paymentInfo.cardBrand || '',
                            }));
                        }
                    } catch (e) { console.log(e); }

                    // Capture product name BEFORE clearing cart for conversion tracking
                    const productName = this.getcartItems.name;

                    // Store payment success info for conversion tracking
                    if (this.conversionId) {
                        sessionStorage.setItem('payment_success', JSON.stringify({
                            amount: amountCharged,
                            user_id: this.user.id,
                            conversion_id: this.conversionId,
                            timestamp: new Date().toISOString()
                        }));
                    }

                    await this.$store.dispatch('setPrescriptionPreauths', response.data.prescriptionPreauths);
                    //await this.saveTrustFrom(this.trustUrl);
                    await this.updateAddress();
                    await this.clearCart();

                    // Navigate and handle conversion tracking
                   let transactionIdentifier;
                    try{
                        if (response.data.transaction_id) {
                            transactionIdentifier = response.data.transaction_id;
                        } else if (response.data.prescriptionPreauths && response.data.prescriptionPreauths.length > 0) {
                            transactionIdentifier = response.data.prescriptionPreauths[0].transactionId;
                        } else {
                            transactionIdentifier = `${response.data.customerId}_${Date.now()}`;
                        }
                    }catch(e){
                        console.log(e)
                        transactionIdentifier = `${Date.now()}`;
                    }


                    await this.pushToRoute(amountCharged, transactionIdentifier, productName);
                    this.submitted = false;

                } else {
                    this.checkoutErrorMessage = response.data.message || "Payment failed";
                    this.submitted = false;
                }
            } catch (error) {
                this.submitted = false;
                this.checkoutErrorMessage = error.response?.data?.message || "Payment failed";
                   
            }
        },

        saveTrustFrom(url) {
            try {
                this.$axios.post(`${this.baseUrl}/api/trust-form`, {
                    "user_id": this.user.id,
                    "url": url
                });
            } catch (error) {
                console.log("error saving url trust");
            }
        },

        // Updated pushToRoute method with enhanced conversion tracking
        async pushToRoute(amountCharged, transaction_id, productName) {
                try {
                    await this.sendConversionTracking(amountCharged, 1, productName);
                    const query = {};
                    if (this.paymentInfo.payment_terms !== null) {
                        query.terms = String(this.paymentInfo.payment_terms);
                    }
                    query.amount = amountCharged;
                    query.trans_id = transaction_id;
                    this.$router.push({
                        name: 'prescriptionThanks',
                        query
                    });
                } catch (error) {
                    console.log(error);
                    this.$router.push({
                        name: 'prescriptionThanks'
                    });
                }
            },

        getSavingsText(value) {
            const monthlyPlanTotal = this.getFirstMonthPrice() + (this.getRegularMonthlyPrice() * (value - 1));
            const prepaidTotal = this.getTotalPrice(value);
            const savings = monthlyPlanTotal - prepaidTotal;
            return `${savings.toFixed(0)} Total Savings`
        },

        showToast(msg) {
            this.toastMessage = '';
            this.$nextTick(() => {
                this.toastMessage = msg;
                setTimeout(() => { this.toastMessage = ''; }, 5000);
            });
        },

        blinkAddress() {
            this.addressBlink = false;
            this.$nextTick(() => {
                this.addressBlink = true;
                setTimeout(() => { this.addressBlink = false; }, 1500);
            });
        },
    },

    computed: {
        ...mapGetters([
            'user',
            'cartItems',
            'cartTotal',
            'cartDiscount',
            'cartTotalNoDiscount'
        ]),

        // Get plan descriptions based on selected payment term
        getPlanPoints() {
            if (this.paymentInfo.payment_terms >= 3) {
                // Calculate correct savings for multi-month plans
                // First month is discounted, remaining months are at regular price
                const monthlyPlanTotal = this.getFirstMonthPrice() + (this.getRegularMonthlyPrice() * (this.paymentInfo.payment_terms - 1));
                const prepaidTotal = this.getTotalPrice(this.paymentInfo.payment_terms);
                const savings = monthlyPlanTotal - prepaidTotal;
                const savingsPercent = ((savings / monthlyPlanTotal) * 100).toFixed(0);

                return [{
                        "header": `${(savings / this.paymentInfo.payment_terms).toFixed(0)} a month savings!`,
                        "sub_header": `You will save ${(savings / this.paymentInfo.payment_terms).toFixed(0)} a month paying for ${this.paymentInfo.payment_terms} months up front (${savings.toFixed(0)} Total Savings) vs. our monthly installment plan.`
                    },
                    {
                        "header": `Save up to ${savingsPercent}%`,
                        "sub_header": `You will save big by paying for our ${this.paymentInfo.payment_terms} month program up front.`
                    }
                ];
            }

            // Monthly plan points remain unchanged
            return [{
                    "header": `${this.getFirstMonthPrice() - this.paymentInfo.discount} for the First Month`,
                    "sub_header": "This amount applies only to the first month, providing an upfront discount to new customers."
                },
                {
                    "header": `${this.getRegularMonthlyPrice()} per month thereafter`,
                    "sub_header": `After the first month, the customer will be charged the regular price of ${this.getRegularMonthlyPrice()} monthly.`
                },
                {
                    "header": "3 Month Supply Program",
                    "sub_header": "You'll receive a 3-month supply of medication, billed monthly. If you cancel before completing the full term, an early termination fee of $279.97 will apply."
                }
            ];
        },

        getOfferName() {
            let offer = this.$store.getters.offerTir;
            if (this.getcartItems.name === 'Semaglutide') {
                offer = this.$store.getters.offerSema;
            }
            return offer;
        },

        getSupplyDuration() {
            return this.paymentTermLabels[this.paymentInfo.payment_terms].supplyDuration;
        },

        getImage() {
            return this.getcartItems.image;
        },

        getcartItems() {
            return this.cartItems[0];
        },

        isMobile() {
            return this.windowWidth < 992;
        },

        isLoggedin() {
            return this.$store.getters.isAuthenticated;
        },

        amountInCents() {
            return Math.round(this.getCurrentPrice() * 100);
        },

        chargeAmountInCents() {
            const totalAmount = this.amountInCents;
            const discountAmount = Math.round((this.paymentInfo.discount || 0) * 100);
            return Math.max(totalAmount - discountAmount, 50);
        },

        finalTotal() {
            if (this.couponApplied) {
                return this.cartTotalNoDiscount - this.paymentInfo.discount;
            }
            return this.cartTotal;
        },

        getDiscount() {
            if (this.couponApplied) {
                return this.paymentInfo.discount;
            }
            return this.cartDiscount;
        }
    }
}
</script>

<style>
.plan-choices-div._6month {
    border-width: 4px;
    border-color: var(--greenbutton-dark);
}

.plan-badge {
    position: absolute;
    top: -10px;
    left: 12px;
    padding: 2px 10px;
    font-size: 10px;
    font-weight: 700;
    border-radius: 20px;
    text-transform: uppercase;
    letter-spacing: 0.5px;
    z-index: 1;
    background-color: #6fcf97;
    color: #fff;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.25);
}

.inline-badge {
    display: inline-block;
    background-color: rgb(0, 163, 108);
    color: #fff;
    font-size: 10px;
    font-weight: 700;
    padding: 2px 10px;
    border-radius: 20px;
    text-transform: uppercase;
    letter-spacing: 0.5px;
    margin-left: 6px;
    vertical-align: middle;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.25);
}

.planactive {
    background-color: var(--light-green);
    color: var(--text-color-button) !important;
}

.plan-link.quart:focus {
    background-color: var(--light-green);
}

.planactive .plan-type-text {
    color: var(--text-color-button) !important;
}

.planactive .plan-price {
    color: var(--text-color-button) !important;
}

.express-element-container {
    display: flex;
    justify-content: center;
    /* Center the buttons horizontally */
    align-items: center;
    /* Align buttons vertically */
    gap: 10px;
    /* Space between buttons */
    width: 100%;
}

.express-right-button,
.express-left-button {
    display: inline-block;
    width: auto;
    /* Default width for both buttons */
}

.express-element-container.single-button .express-right-button,
.express-element-container.single-button .express-left-button {
    width: 75%;
    /* 75% width for a single button on larger screens */
}

@media (max-width: 768px) {

    /* Target mobile devices */
    .express-element-container {
        flex-direction: column;
        /* Stack buttons vertically */
        gap: 15px;
    }

    .express-right-button,
    .express-left-button {
        width: 100%;
        /* 100% width for all buttons on mobile */
    }

    .express-element-container.single-button .express-right-button,
    .express-element-container.single-button .express-left-button {
        width: 100%;
        /* Single button takes full width on mobile */
    }
}

.checkout-product-div {
    background-color: #c9e8ff;
    background-image: none;
}

.google-pay-button-container {
    height: 48px !important;
}

.google-pay-button {
    height: 48px !important;
}

.div-block-1154-centered {
    flex-flow: column;
    justify-content: center;
    align-items: center;
    display: flex;
    padding-left: 10px;
}

.image-31-desk {
    margin-top: 15px;
    width: auto;
    height: 22px;
    margin-bottom: 0;
}

.submit-button-3.new:hover {
    background-color: rgb(0, 163, 108);
}

.button-103.new {
    background-color: var(--light-green);
}

.plan-savings-text {
    color: #fff;
}

.save-more-div {
    flex-flow: column;
    justify-content: center;
    align-items: center;
    margin-top: -20px;
    margin-bottom: -5px;
    display: flex;
    position: relative;
}

.save-more-text {
    background-color: var(--light-green);
    font-family: var(--mulish);
    color: var(--black);
    text-align: center;
    border: 1px solid #000;
    border-radius: 99px;
    padding: 3px 10px;
    font-weight: 900;
    z-index: 1;
}

.text-block-1300 {
    font-family: var(--mulish);
    color: var(--black);
    margin-bottom: 20px;
    font-size: 16px;
    line-height: 22px;

}

.text-span-290 {
    font-weight: 900;
}

.select-plan-text {
    margin-bottom: 1px;
}

/* Stripe split card elements */
.form-row {
    display: flex;
    gap: 15px;
}
.form-row .form-group {
    flex: 1;
}
.form-group {
    margin-bottom: 10px;
}
.form-group label {
    display: block;
    font-size: 13px;
    font-weight: 600;
    margin-bottom: 5px;
    color: #333;
    font-family: var(--mulish);
}

/* Express checkout */
.express-checkout-section {
    margin-bottom: 15px;
}
.express-checkout-box {
    margin-bottom: 10px;
}
.payment-request-btn-container {
    height: 48px;
}
.pe-divider {
    display: flex;
    align-items: center;
    gap: 10px;
    margin: 15px 0;
    font-family: var(--mulish);
    font-size: 13px;
    color: #999;
}
.pe-divider-line {
    flex: 1;
    height: 1px;
    background: #ddd;
}

/* Klarna button */
.klarna-btn {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 8px;
    width: 100%;
    height: 48px;
    background-color: #FFB3C7;
    border: none;
    border-radius: 4px;
    cursor: pointer;
    margin-top: 10px;
    font-family: var(--mulish);
    font-size: 14px;
    font-weight: 600;
    color: #000;
    transition: background-color 0.2s;
}
.klarna-btn:hover {
    background-color: #ff9db5;
}
.klarna-btn:disabled {
    opacity: 0.6;
    cursor: not-allowed;
}
.klarna-btn-text {
    font-size: 14px;
}
.klarna-logo {
    height: 20px;
    width: auto;
}

/* Override Webflow CSS to show mobile layout at tablet sizes */
@media screen and (max-width: 991px) {
    .sema-checkout-mobile {
        display: block !important;
    }
    .semaco_wrap {
        display: none !important;
    }
}

/* Mobile express checkout grid */
@media screen and (max-width: 479px) {
    .express-checkout-box {
        display: grid;
        grid-template-columns: 1fr 1fr;
        gap: 12px;
        padding: 16px;
        align-items: stretch;
    }
    .payment-request-btn-container {
        min-height: 48px;
    }
    .payment-request-btn-container:only-child {
        grid-column: 1 / -1;
    }
    .klarna-btn {
        flex-direction: column;
        padding: 4px 6px;
        gap: 2px;
        height: 48px;
        margin-top: 0;
    }
    .klarna-btn:only-child,
    .express-checkout-box.single-option .klarna-btn {
        grid-column: 1 / -1;
    }
    .klarna-btn-text {
        font-size: 11px;
        white-space: nowrap;
    }
    .klarna-logo {
        height: 16px;
    }
}

/* Checkout API error banner */
.checkout-error-banner {
    background: #fef2f2;
    border: 1px solid #fca5a5;
    border-radius: 8px;
    padding: 16px;
    margin-bottom: 16px;
}
.checkout-error-banner-content {
    display: flex;
    gap: 12px;
    align-items: flex-start;
}
.checkout-error-icon {
    font-size: 20px;
    line-height: 1;
    flex-shrink: 0;
}
.checkout-error-heading {
    font-weight: 700;
    color: #991b1b;
    margin-bottom: 4px;
}
.checkout-error-message {
    color: #991b1b;
    margin-bottom: 4px;
    font-size: 14px;
}
.checkout-error-helper {
    color: #b91c1c;
    font-size: 13px;
}

/* Error toast */
.error-toast {
    position: fixed;
    top: 20px;
    left: 50%;
    transform: translateX(-50%);
    width: 90%;
    max-width: 400px;
    background: #dc2626;
    color: #fff;
    padding: 16px 20px;
    border-radius: 8px;
    font-size: 15px;
    font-weight: 600;
    z-index: 99999999;
    box-shadow: 0 4px 20px rgba(0, 0, 0, 0.3);
    animation: toast-in 0.3s ease, toast-out 0.3s ease 4.7s;
    text-align: center;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 12px;
}
.toast-close {
    background: none;
    border: none;
    color: #fff;
    font-size: 22px;
    cursor: pointer;
    padding: 0;
    line-height: 1;
    opacity: 0.8;
    flex-shrink: 0;
}
.toast-close:hover {
    opacity: 1;
}
@keyframes toast-in {
    from { opacity: 0; transform: translateX(-50%) translateY(-20px); }
    to { opacity: 1; transform: translateX(-50%) translateY(0); }
}
@keyframes toast-out {
    from { opacity: 1; transform: translateX(-50%) translateY(0); }
    to { opacity: 0; transform: translateX(-50%) translateY(-20px); }
}

/* Processing payment overlay */
.processing-overlay {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.5);
    z-index: 99999;
    display: flex;
    align-items: center;
    justify-content: center;
}
.processing-box {
    background: #fff;
    border-radius: 12px;
    padding: 40px 50px;
    text-align: center;
    box-shadow: 0 4px 20px rgba(0, 0, 0, 0.2);
}
.processing-box img {
    width: 50px;
    margin-bottom: 16px;
}

/* Address blink */
.address-highlight input {
    animation: blink-red 0.5s ease 3;
}
@keyframes blink-red {
    0%, 100% { border-color: inherit; }
    50% { border-color: #dc2626; box-shadow: 0 0 0 2px rgba(220, 38, 38, 0.3); }
}

.pe-label-7x {
    font-weight: 350 !important;
    color: #4a4a57 !important;
    font-size: 0.9rem !important;
    line-height: 1.15 !important;
    margin-bottom: 4px !important;
    font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu, Cantarell, 'Open Sans', 'Helvetica Neue', sans-serif !important;
}
@media screen and (max-width: 991px) {
    .pe-label-7x {
        font-size: 16px !important;
        color: #000 !important;
    }
}

</style>
